import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Injectable({
	providedIn: 'root',
})
export class AuthLoginService {
	private http = inject(HttpClient);
	private Router = inject(Router);

	private authUrl = environment.baseApiUrl + 'mysupportauth/generateToken';
	private deleteSessionStatus = environment.baseApiUrl + 'mysupportauth/sessionStatus?{qryString}';
	private resetPassword = environment.baseApiUrl + 'tool/emailResetPassword';
	private checkTokenUrl = environment.baseApiUrl + 'mysupportauth/checkToken';
	private getSAMLLogin = environment.baseApiUrl + 'access/SAMLLogin?customer_page={customer_page}';
	private getSAMLLogoff = environment.baseApiUrl + 'access/SAMLLogoff?customer_page={customer_page}';
	public allowedNotToBeLoggedPages = ['/login'];

	constructor() {}

	generateSessionToken(email: string, password: string): Observable<JSON> {
		const body = { email: email, password: password };
		return this.http.post<JSON>(this.authUrl, body);
	}

	sendMail(email: string, cryptAES: string, url: string): Observable<JSON> {
		const body = {
			emailTo: email,
			encryptedEmailAES: cryptAES,
			customerUrl: url,
		};
		return this.http.post<JSON>(this.resetPassword, body);
	}

	setSessionToken(token: string): void {
		if (token) localStorage.setItem('authToken', token);
		else throw new Error('Cannot set authToken with undefined');
	}

	removeSessionToken(): void {
		localStorage.removeItem('authToken');
	}

	getSessionToken(): string {
		return localStorage.getItem('authToken');
	}

	setSessionStatus(status: string): void {
		if (status == undefined) {
			throw new Error('Cannot set sessionStatus widh undefined');
		} else {
			localStorage.setItem('sessionStatus', status.toString());
		}
	}

	removeSessionStatus(idEnduser: string, idAnalyst: string): void {
		localStorage.removeItem('sessionStatus');
		let qryString = '';

		if (idEnduser) qryString += idEnduser ? `enduser=${idEnduser}` : '';
		else if (idAnalyst) qryString += idAnalyst ? `analyst=${idAnalyst}` : '';
		else throw 'No id enduser nor id analyst on logout';
		const deleteSessionStatus = this.deleteSessionStatus.replace('{qryString}', qryString);
		this.http.delete(deleteSessionStatus).subscribe();
	}

	getSessionStatus(): string {
		return localStorage.getItem('sessionStatus');
	}

	getHttpHeaders(): HttpHeaders {
		return new HttpHeaders({
			Authorization: 'Bearer ' + this.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
	}

	isLoggedIn(): boolean {
		return this.getSessionToken() ? true : false;
	}

	checkToken(token: string): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + token,
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.http.get(this.checkTokenUrl, { headers: headers });
	}

	checkSAMLLogin(customer_page: string): Observable<[{ redirect: string }]> {
		const getSAMLLogin = this.getSAMLLogin.replace('{customer_page}', customer_page);
		return this.http.get<[{ redirect: string }]>(getSAMLLogin);
	}

	checkSAMLLogoff(customer_page: string): Observable<[{ redirect: string }]> {
		const getSAMLLogoff = this.getSAMLLogoff.replace('{customer_page}', customer_page);
		return this.http.get<[{ redirect: string }]>(getSAMLLogoff);
	}

	logoff(idEnduser: string, idAnalyst: string): void {
		this.checkSAMLLogoff(location.hostname).subscribe((redirect) => {
			this.removeSessionToken();
			this.removeSessionStatus(idEnduser, idAnalyst);
			location.href = redirect[0].redirect == '' ? '/login' : redirect[0].redirect;
			localStorage.setItem('updateEvent', Math.random().toString());
		});
	}
}
